import { Component, inject } from '@angular/core';
import { ContractVariableService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractVariableCreateDto,
  ContractVariableDto,
  ContractVariableExcelDownloadDto,
  ContractVariableUpdateDto,
} from '../proxy/controlling/dtos/contract-variable';
import { CONTRACTVARIABLE_CONFIG, CONTRACTVARIABLE_FIELDS } from './contract-variable.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-variable',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractVariableService, ConfirmationService],
  templateUrl: './contract-variable.html',
  styleUrl: './contract-variable.scss',
})
export class ContractVariable extends BaseCrudComponent<
  ContractVariableDto,
  ContractVariableCreateDto,
  ContractVariableUpdateDto,
  ContractVariableExcelDownloadDto
> {
  service = inject(ContractVariableService);
  config = CONTRACTVARIABLE_CONFIG;
  fields = CONTRACTVARIABLE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractVariableDto): ContractVariableUpdateDto {
    return {
      variableName: data.variableName,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractVariable';
  }
}
